export function isNutualRentDomain(): boolean {
  const { hostname } = new URL(window.location.href)
  if (hostname.includes('nutual-rent') || hostname.includes('localhost')) {
    return true
  }
  return false
}
